export default "<p>cash-credit-detail works!</p>\r\n"